import React from "react";
import { Spinner } from "react-bootstrap";
import loading_box from "../assets/img/loading_box.svg";

export const Loader = () => (
  <div className="d-flex flex-column align-items-center justify-content-center my-3">
    <h3 className="px-2 mb-3 font-weight-bold"> Loading... </h3>
    <Spinner animation="border" variant="secondary" />
  </div>
);

export const LoadingBox = () => (
  <div className="d-flex flex-column align-items-center justify-content-center my-3">
    <h3 className="px-2 mb-3 font-weight-bold">Loading...</h3>
    <img style={{ height: "125px" }} src={loading_box} alt="Loading Box" />
  </div>
);

export default Loader;
